import React from 'react';
import _ from 'lodash';
import { Timeline } from 'antd';
import { FormattedMessage } from 'react-intl';
import TextPreview from '../../Utils/TextPreview/TextPreview';
import styles from './CandidateWorkHistory.module.scss';
import { SmartIcon } from '../../Icons/AryaIcons';
import CalculatePromotion from '../../Utils/PromotionCalculator';
import {
  getExperienceDuration,
  getExperienceTimeline,
  getExperienceDurationFromMonths,
} from '../../Utils/CandidateListUtils';
import { highlightKeyWords } from '../../Utils/KeywordHighlightUtil';
import message from '../../Containers/ManualSearchV2/ManualSearchMessages';

function CandidateWorkHistory(props) {
  const {
    experiences = [],
    name,
    appName,
    workExperience,
    keywordsToHighlight,
    mustHavesKeywords = [],
    candidateDetailsStatus,
    candidate,
    activeTab,
    activeSourceName,
  } = props;
  const noOfPormotions = CalculatePromotion(experiences);
  function generateAllHighlightKeywords(keywordsToHighlight, activeTab, activeSourceName, candidate) {
    return _.uniq([
      ...(keywordsToHighlight || []),
      ...(activeTab === 'sourced' && activeSourceName !== 'AryaRecommended' ? [] : candidate.Keywords || []),
    ]);
  }

  const [allHighlightKeywords, setAllHighlightKeywords] = React.useState([]);
  React.useEffect(() => {
    if (candidateDetailsStatus === 'COMPLETED') {
      const allHighlights = generateAllHighlightKeywords(keywordsToHighlight, activeTab, activeSourceName, candidate);
      const domSelectors = ['div#candidate-360-work-history'];
      const mergedKeywordsList = [...allHighlights, ...mustHavesKeywords];
      setAllHighlightKeywords(mergedKeywordsList);
      highlightKeyWords(domSelectors, mergedKeywordsList);
      highlightKeyWords(domSelectors, mustHavesKeywords, 'mustHaveMark');
    }
  }, [candidateDetailsStatus, keywordsToHighlight, mustHavesKeywords]);

  return (
    <div id="candidate-360-work-history">
      {experiences.length ? (
        <div>
          <div className={styles.historySummary}>
            <SmartIcon />
            <span>
              {name ?? appName} <FormattedMessage {...message.hasHadLabel} /> {noOfPormotions}{' '}
              <FormattedMessage {...message.promotionsRolesInTheLastLabel} /> {workExperience}{' '}
              <FormattedMessage {...message.YearsLabel} />
            </span>
          </div>
          <Timeline>
            <div className={styles.historyTimeline}>
              {experiences.map(experience => {
                const text = experience?.Summary?.trim();
                const experienceTimeline = getExperienceTimeline(experience);
                let timeline;
                const duration = getExperienceDuration(experience) || getExperienceDurationFromMonths(experience);
                if (experience.Company && experienceTimeline) {
                  timeline = (
                    <div className={styles.companyName}>{`${experience.Company} | ${experienceTimeline}`}</div>
                  );
                } else if (experience.Company) {
                  timeline = <div className={styles.companyName}>{experience.Company}</div>;
                } else if (experienceTimeline) {
                  timeline = <div className={styles.companyName}>{experienceTimeline}</div>;
                } else {
                  timeline = null;
                }
                return (
                  <div className={styles.timelineItem} key={experience}>
                    <Timeline.Item color="#52C41A" key={experience}>
                      <div>
                        <div className={styles.titleAndDuration}>
                          <div className={styles.jobTitle}>{experience.Title}</div>
                          {duration ? <span>({duration})</span> : null}
                        </div>
                        {timeline}
                        <div className={styles.cardView}>
                          <TextPreview
                            text={text}
                            shouldSetSeeMoreButton
                            partialClassName={styles.partialClass}
                            keywords={allHighlightKeywords}
                          />
                        </div>
                      </div>
                    </Timeline.Item>
                  </div>
                );
              })}
            </div>
            <div className={styles.hiddenTimeline}>
              <Timeline.Item dot={<div />}></Timeline.Item>
            </div>
          </Timeline>
        </div>
      ) : (
        <div>
          <SmartIcon />
          <span>
            <FormattedMessage {...message.noWorkHistoryAvailableLabel} />
          </span>
        </div>
      )}
    </div>
  );
}

export default CandidateWorkHistory;
